"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarFooterButtons;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SimpleDate = require("../../core/SimpleDate");

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _UITooltip = _interopRequireDefault(require("../../tooltip/UITooltip"));

var _SimpleDateTypes = require("../../types/SimpleDateTypes");

var _lazyEval = _interopRequireDefault(require("../../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../../utils/propTypes/createLazyPropType"));

var _CalendarFooterButton = _interopRequireDefault(require("./CalendarFooterButton"));

var Outer = _styledComponents.default.div.withConfig({
  displayName: "CalendarFooterButtons__Outer",
  componentId: "sc-17bm11x-0"
})(["display:flex;justify-content:space-between;margin:16px 0 20px;"]);

var FooterButton = (0, _styledComponents.default)(_CalendarFooterButton.default).withConfig({
  displayName: "CalendarFooterButtons__FooterButton",
  componentId: "sc-17bm11x-1"
})(["flex-basis:50%;"]);

function CalendarFooterButtons(props) {
  var clearLabel = props.clearLabel,
      max = props.max,
      maxValidationMessage = props.maxValidationMessage,
      min = props.min,
      minValidationMessage = props.minValidationMessage,
      onChange = props.onChange,
      today = props.today,
      todayLabel = props.todayLabel,
      rest = (0, _objectWithoutProperties2.default)(props, ["clearLabel", "max", "maxValidationMessage", "min", "minValidationMessage", "onChange", "today", "todayLabel"]);
  var todayButtonDisabled = !(0, _SimpleDate.isDateInRange)(today, min, max);
  return _react.default.createElement(Outer, rest, _react.default.createElement(_UITooltip.default, {
    title: todayButtonDisabled && (0, _lazyEval.default)(min && (0, _SimpleDate.compare)(today, min) === -1 ? minValidationMessage : maxValidationMessage)
  }, _react.default.createElement(FooterButton, {
    "data-action": "today",
    disabled: todayButtonDisabled,
    onClick: function onClick() {
      onChange((0, _SyntheticEvent.default)(today));
    }
  }, (0, _lazyEval.default)(todayLabel))), _react.default.createElement(FooterButton, {
    "data-action": "clear",
    onClick: function onClick() {
      onChange((0, _SyntheticEvent.default)(null));
    }
  }, (0, _lazyEval.default)(clearLabel)));
}

if (process.env.NODE_ENV !== 'production') {
  CalendarFooterButtons.propTypes = {
    clearable: _propTypes.default.bool,
    clearLabel: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired,
    max: _SimpleDateTypes.SimpleDateType,
    maxValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string),
    min: _SimpleDateTypes.SimpleDateType,
    minValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string),
    onChange: _propTypes.default.func.isRequired,
    today: _SimpleDateTypes.SimpleDateType.isRequired,
    todayLabel: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired
  };
}

CalendarFooterButtons.defaultProps = {
  clearable: true,
  clearLabel: function clearLabel() {
    return _I18n.default.text('ui.datePicker.clear');
  },
  todayLabel: function todayLabel() {
    return _I18n.default.text('ui.datePicker.today');
  }
};
CalendarFooterButtons.displayName = 'CalendarFooterButtons';
module.exports = exports.default;